export default __webpack_public_path__ + "static/media/Flag_of_Timor_Leste.0b6c056b.svg";